import { render, staticRenderFns } from "./modalTwo.vue?vue&type=template&id=efc4fd64"
import script from "./modalTwo.vue?vue&type=script&lang=js"
export * from "./modalTwo.vue?vue&type=script&lang=js"
import style0 from "./modalTwo.vue?vue&type=style&index=0&id=efc4fd64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports